/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Confirm/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function Confirm({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Form/ReferralsSection/New/Confirm/Content/Referral/Actions/Confirm",
  onSubmit
  
}) {
let newReferralSubmitData = fromData.useDataSubmit({ viewPath,
context: 'new_referral',
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="secondary"
 data="new_referral"
 onClick={newReferralSubmitData}
 text="Add"
/>
{children}
</React.Fragment>)
}